import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { Ascii } from "./routes/ascii"
import { ErrorPage } from "./routes/ErrorPage"
import { Root } from "./routes/Root"
import WireSize from "./routes/wireSize"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />
  },
  {
    path: "/ascii",
    element: <Ascii />
  },
  {
    path: "/wireSize",
    element: <WireSize />
  }
])

export function Main() {
  return <div>
    <RouterProvider router={router} />
  </div>
}